/** Skip redundant navigations that trigger history.replaceState floods. */

import type { NavigateFunction } from "react-router-dom";

export function currentPathWithSearch(): string {
  if (typeof window === "undefined") {
    return "";
  }
  return window.location.pathname + window.location.search;
}

export function replacePathIfChanged(navigate: NavigateFunction, href: string): void {
  const target = href.startsWith("/") ? href : `/${href}`;
  if (currentPathWithSearch() === target) {
    return;
  }
  navigate(target, { replace: true });
}

/** Auth0 returns to `/login?code=…&state=…`; SDK must finish before starting another redirect. */
export function isAuth0CallbackInProgress(): boolean {
  if (typeof window === "undefined") {
    return false;
  }
  const params = new URLSearchParams(window.location.search);
  return params.has("code") && params.has("state");
}
